/**
 * 为数字添加千位符
 * @param num 数字或字符串
 * @returns 带千位符的字符串
 */
export function addThousandsSeparator(num: number | string): string {
  const numStr = typeof num === 'string' ? num : num.toString();
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 格式化金额，添加千位符并限制小数位数
 * @param amount 金额数字或字符串
 * @param displayDigits 显示的小数位数，默认为2
 * @returns 格式化后的金额字符串
 */
export function formatAmount(amount: number | string, displayDigits: number = 2): string {
  // 转换为字符串进行处理
  let amountStr: string;
  if (typeof amount === 'string') {
    amountStr = amount;
  } else {
    amountStr = amount.toString();
  }
  
  // 分离整数部分和小数部分
  let [integerPart, decimalPart] = amountStr.split('.');
  
  // 为整数部分添加千位符
  const formattedIntegerPart = addThousandsSeparator(integerPart);
  
  // 如果没有小数部分，直接返回带千位符的整数
  if (!decimalPart) {
    return formattedIntegerPart;
  }
  
  // 截取小数部分到指定位数（不四舍五入）
  let truncatedDecimalPart = decimalPart.slice(0, displayDigits);
  
  // 去除尾部的0
  while (truncatedDecimalPart.endsWith('0') && truncatedDecimalPart.length > 0) {
    truncatedDecimalPart = truncatedDecimalPart.slice(0, -1);
  }
  
  // 如果小数部分全部被去除，只返回整数部分
  if (truncatedDecimalPart.length === 0) {
    return formattedIntegerPart;
  }
  
  // 返回完整的格式化数字
  return `${formattedIntegerPart}.${truncatedDecimalPart}`;
}
